

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import { CloseCircleOutlined } from '@ant-design/icons';
import CouponDialog from '../dialog/coupon';
import can from '../../../../components/ability';


export default (props) => {
    
    const { value, onChange, schema } = props;
    const { multi = true } = schema;
    const [showChoose, setShowChoose] = useState(false);
    const [list, setList] = useState([]);
    const globalConfig = useContext(FormConfigContext);
    const { accId, shopId } = globalConfig;

    const getCouponList = async () => {
        if (!shopId) return;
        
        const response = await fetch('/api/coupon/list' + '?shopId=' + shopId);
        const result = await response.json();

        if (result?.success) {
            return result.data.rows.filter(i => {
                const {
                    triggerAmount, type, offerAmount, title
                } = i;
                i.contentDesc = `${title}: 满${triggerAmount / 100}元${type===1 ? '减': '折扣'}${type===1 ? offerAmount / 100 : offerAmount}${type===1 ? '元': '%'}`
                return i.status !== 0;
            })
        }else {
            message.error(result.message);
            return []
        }
    }; 
    function clearValue(e) {
        e.stopPropagation()
        onChange();
    }
    useEffect(() => {
        getCouponList().then(res => setList(res));
        return;
    }, []);

    const showList = [];
    let forList = value || [];
    if (!Array.isArray(forList)) {
        forList=[value]
    }
    forList.forEach(v => {
        let find = list.find(i => i.couponTmpId === v);
        if (find) {
            showList.push(find)
            return;
        }
    })
    
    
    return (
        <div className='comp-form-customer-field'>
            <CouponDialog
                visible={showChoose}
                onClose={() => setShowChoose(false)}
                onChange={(value) => {onChange(multi?value: value[0]); setShowChoose(false);}}
                multi={multi}
                value={showList.map(i => i.couponTmpId)}
                list={list}
            />
            <div className={`comp-form-choose-item ${showList.length > 0 ?'':'empty'}`} onClick={() => setShowChoose(true)}>
                {
                    showList.map(i => i.contentDesc).join(', ') || '点击选择优惠券'
                }
                <CloseCircleOutlined className='clear-value' onClick={clearValue} />
            </div>
        </div>
    );
};